import { getRandomString } from '@tencent/v-common-utils';
import { getInitialGlobalData } from '@/apis/global';
import { InitialGlobalData } from '@/types/global';
import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';
import getters from './getters';
import account from './modules/account';
import app from './modules/app';
import route, { State as routeState } from './modules/route';
import getAegis from '@/utils/aegis';

Vue.use(Vuex);

interface State {
  initialGlobalData: InitialGlobalData;
  route?: routeState;
}

const aegis = getAegis();

const state: State = {
  initialGlobalData: { nativeVersion: '', userId: getRandomString(10), device: { system: '', brand: '' } },
};

const mutations = {
  updateInitialGlobalData(state: State, initialGlobalData: InitialGlobalData) {
    state.initialGlobalData = initialGlobalData;
  },
};

const actions = {
  async updateInitialGlobalData({ commit }: ActionContext<State, State>) {
    try {
      const result = await getInitialGlobalData();
      commit('updateInitialGlobalData', result);
      console.log('AccountInfo initial global data: ', result);
      aegis?.setConfig({
        ext3: result.nativeVersion || 'native version not get',
      });
      return Promise.resolve(result);
    } catch (error) {
      console.error('Error. updateInitialGlobalData failed.', error);
    }
  },
};

const store = new Vuex.Store({
  modules: {
    account: account as any,
    route,
    app,
  },
  state,
  getters,
  actions,
  mutations,
});

export default store;
